import React, { FC } from 'react';
import { useController } from 'react-hook-form';
import AsyncSelect from 'react-select/async';
import { ErrorMessage } from '@hookform/error-message';
import NoSsr from '@common/noSsr';
import FieldContainer from '@common/FieldContainer';
import { useAffiliatedUniversities } from '@repository/partnership/usePartnership';
import { ReactSelectInputStyles } from './ReactSelectStyles';
import { LoadOptions } from '@domain/constant/ReactSelectOption';

import useDebounce from '@utils/hooks/useDebounce';
import classnames from 'classnames/bind';
import styles from '../premium.module.scss';

const cx = classnames.bind(styles);

interface SchoolProps {
  name: string;
}

const School: FC<SchoolProps> = ({ name }) => {
  const { data: allUniversites } = useAffiliatedUniversities();
  const convertAllUniversitesToOptions = allUniversites?.universities.map((university) => ({
    value: university.code,
    label: university.name,
  }));
  const { field, fieldState } = useController({
    name,
    defaultValue: null,
    rules: {
      validate: (value) => {
        if (!value) return '학교를 선택해 주세요.';
        return true;
      },
    },
  });

  const getSchoolsOption = useDebounce((keyword: string, callback: LoadOptions) => {
    const input = keyword.toLowerCase();
    callback(
      convertAllUniversitesToOptions?.filter((item) => item.label.toLowerCase().includes(input)).slice(0, 50) ?? [],
    );
  }, 100);

  return (
    <FieldContainer name="제휴 대학" required={true}>
      <div className={cx('selectArea')}>
        <NoSsr>
          <AsyncSelect
            {...field}
            className={cx('select', { error: fieldState.invalid })}
            loadOptions={getSchoolsOption}
            placeholder={'학교를 검색해 주세요.'}
            openMenuOnClick={false}
            styles={ReactSelectInputStyles}
            isClearable={true}
            noOptionsMessage={() => '제휴 대학이 아닙니다.'}
          />
        </NoSsr>
        <div className={cx('noticeTextArea')}>
          <span className={cx('noticeText', { hidden: fieldState.invalid })}>제휴된 대학만 인증 가능합니다.</span>
          <span className={cx('noticeText', 'error')}>{<ErrorMessage name={name} />}</span>
        </div>
      </div>
    </FieldContainer>
  );
};

export default School;
